import "./skeleton.scss";

const SkeletonCircleLoader = ({ size = 35 }: { size?: number }) => {
  return (
    <div
      className="skeleton-circle-loader"
      style={{ width: `${size}px`, height: `${size}px` }}
    ></div>
  );
};

export default SkeletonCircleLoader;
